import BaseService from './base.service';

export default class TemplateService extends BaseService {
  getTemplates(companyUuid) {
    return this.get(`template/list/${companyUuid}`);
  }

  getTemplateById(stateUuid) {
    return this.get(`template/state/${stateUuid}`);
  }

  editTemplate(uuid) {
    return this.get(`template/edit/${uuid}`);
  }

  saveCompanyTemplate(companyUuid, data) {
    return this.create(`company/template/${companyUuid}`, data);
  }

  saveTemplate(companyUuid, data) {
    return this.create(`template/save/${companyUuid}`, data);
  }

  updateTemplate(templateUuid, data) {
    return this.create(`template/update/${templateUuid}`, data);
  }

  getTemplateVariables() {
    return this.get('editor/list');
  }
}
